import axios from "axios";

export default function () {
  axios.interceptors.request.use(function (config) {
    const envServices =
      config.appGlobals.envSelector[
        config.isMock ? "mockVueEnvConfig" : "selectedVueEnvConfig"
      ].value.services;
    let serviceConfig = null;
    let serviceMatchedUrl = "";

    Object.keys(envServices).forEach((serviceKey) => {
      let curSeviceUrl = envServices[serviceKey].url;
      if (
        config.url.substring(0, curSeviceUrl.length) == curSeviceUrl &&
        curSeviceUrl.length > serviceMatchedUrl.length
      ) {
        serviceConfig = envServices[serviceKey];
        serviceMatchedUrl = curSeviceUrl;
      }
    });

    Object.assign(config, {
      serviceConfig,
    });

    if (serviceConfig?.headers)
      Object.assign(config.headers, serviceConfig.headers);

    return config;
  }, null);

  axios.interceptors.response.use(null, function (error) {
    if (error.response?.data) {
      try {
        error.response.data = JSON.parse(error.response.request.responseText);
      } catch (e) {
        console.log("error in setting error.response.data", e);
      }
    }
    throw error;
  });
}
